import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-questions-and-answers',
  templateUrl: './questions-and-answers.component.html',
  styleUrls: ['./questions-and-answers.component.scss'],
})
export class QuestionsAndAnswersComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
